module.exports = __webpack_public_path__ + "img/ME.804c83e6.svg";